import axios from 'axios'

export const today = params => { return axios.get(`/courses/today`, { params: params }) }
export const listpage = params => { return axios.get(`/courses/group`, { params: params }) }
export const all = params => { return axios.get(`/courses`, { params: params }) }
export const remove = params => { return axios.delete(`/courses/group/` + params.id, { params: params }) }
export const get = params => { return axios.get(`/courses/group/` + params.id, { params: params }) }
export const save = params => { return params.id ? axios.put(`/courses/group`, params) : axios.post(`/courses/group`, params) }
export const targetList = params => { return axios.get(`/courses/target/list`, { params: params }) }
export const categoryList = params => { return axios.get(`/courses/category/list`, { params: params }) }

export const group = {
  search (params) { return axios.get(`/courses/schedules?type=2`, { params: params }) },
  get (params) { return axios.get(`/courses/group/schedules/` + params.id, { params: params }) },
  getschedule (params) { return axios.get(`/course/schedule/` + params.id, { params: params }) },
  save (params) { return params.id ? axios.put(`/courses/group/schedules`, params) : axios.post(`/courses/group/schedules`, params) },
  remove (params) { return axios.delete(`/courses/group/schedules/${params.id}`, { params: params }) },
  reserve: {
    remove (params) { return axios.delete(`/courses/group/reserve`, { params: params }) } }
}
export const personal = {
  search (params) { return axios.get(`/courses/schedules?type=1`, { params: params }) }
}



// WEBPACK FOOTER //
// ./src/services/api/course/index.js